<template>
  <Transition name="fade">
    <div
      v-if="isOpen"
      class="fixed inset-0 z-[10000] flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm"
      @click.self="emit('close')"
    >
      <div
        class="relative w-full max-w-md rounded-[20px] border border-tertiary bg-secondary p-8 shadow-2xl"
      >
        <h2 class="mb-6 border-b border-tertiary pb-4 text-xl font-bold text-accent">
          Projekt teilen
        </h2>
        <div class="mb-6">
          <p v-if="!isPublic" class="text-sm text-text-main">
            Dieses Projekt ist aktuell privat. Durch das Teilen wird es öffentlich — jeder mit dem
            Link kann es ansehen.
          </p>
          <p v-else class="text-sm text-text-main">
            Kopiere den Link, um dieses Projekt zu teilen.
          </p>
        </div>

        <div class="flex items-center justify-end gap-3">
          <button
            type="button"
            data-testid="share-confirm"
            class="cursor-pointer rounded-standard bg-accent px-6 py-2 text-sm font-semibold text-text-main shadow-sm transition-all duration-150 hover:brightness-110"
            @click="submit"
          >
            {{ isPublic ? 'Link kopieren' : 'Öffentlich machen & Link kopieren' }}
          </button>

          <button
            type="button"
            class="cursor-pointer rounded-standard border border-tertiary bg-primary px-6 py-2 text-sm font-semibold text-text-main transition-colors duration-150 hover:bg-primary/80"
            @click="emit('close')"
          >
            Abbrechen
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
defineProps<{
  isOpen: boolean
  projectId: string
  projectTitle: string
  isPublic: boolean
}>()

const emit = defineEmits<{
  (event: 'close'): void
  (event: 'confirm'): void
}>()

function submit() {
  emit('confirm')
  emit('close')
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
